import React from 'react';
import VoicePicker from '../../VoicePicker';
import {COPY_STRINGS} from '../../../constants/translatedCopy';

export default class GradePicker extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      buttonsDisabled: true,
    };

    this.options = [
      {name: COPY_STRINGS.kindergarten, grade: 0},
      {name: COPY_STRINGS.first_grade, grade: 1},
      {name: COPY_STRINGS.second_grade, grade: 2},
      {name: COPY_STRINGS.third_grade, grade: 3},
    ];

    this.title = COPY_STRINGS.what_grade;
    this.prompt = COPY_STRINGS.didnt_understand + " " + COPY_STRINGS.what_grade;

    this.selectOption = this.selectOption.bind(this);
  }

  componentDidMount(){
    this.sayPrompt();
  }

  sayPrompt(){
    let props = {};

    // enable the buttons once speech starts
    // TODO: reduce duplication with StoryPicker
    props.onStart= (
      function(event){
        this.setState({
          buttonsDisabled: false,
        });
      }
    ).bind(this);

    props.textToSpeak = this.title;
    props.skipAvatar = false;
    //Send the proper sentence to the TTS object
    this.props.speech.speak(props, true);
  }

  // returns a function to select a given story
  selectOption(option){
    this.props.selectGrade(option.grade);
    this.setState({buttonsDisabled: true});
    if(this.props.speech){
      this.props.speech.abortSpeech();
    }
  }

  render() {
    return (
      <VoicePicker
        options={this.options}
        speech={this.props.speech}
        title={this.title}
        prompt={this.prompt}
        selectOption={this.selectOption}
        close={this.props.close}
        buttonsDisabled={this.state.buttonsDisabled}
      />
    );
  }
}
